import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const processSlice = createSlice({
    name: 'process',
    initialState,
    reducers: {
        funGetProcess(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map((process ) =>{
                return{
                    ...process,
                    devDt: m.date({ value: process.devDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const processActions = processSlice.actions;
export default processSlice.reducer;